import React, { useState, useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import axios from 'axios';
import { ButtonSpinnerSlot } from '../ui/ButtonSpinner';
import { TextField, FormControlLabel, Checkbox, Typography } from '@mui/material';
import { FixedSizeList as List } from 'react-window';

export default function QuestionsShowDialog({ open, handleClose, testId }) {
    const [questions, setQuestions] = useState([]);
    const [loading, setLoading] = useState(false); 

    useEffect(() => {
        const fetchQuestions = async () => {
            if (testId !== '') {
                const bodyques = {
                    test_id: testId,
                };
                const apiUrl1 = process.env.REACT_APP_API_URL1;
                const token = localStorage.getItem('token');
                try {
                    const response = await axios.post(apiUrl1 + "/api/user/fetch_question", bodyques, {
                        headers: {
                            'Content-Type': "application/json",
                            "Accept": "*/*",
                            "Access-Control-Allow-Origin": "*",
                            'Authorization': token,
                            "X-Api-Version": 'v2'
                        }
                    });

                    setQuestions(response.data.data);
                } catch (error) {
                    console.error("Error:", error);
                }
            }
        };

        fetchQuestions();
    }, [testId]);

    const handleContentChange = (e, index, field) => {
        const updatedContent = [...questions];
        if (field === 'question') {
            updatedContent[index].question = e.target.value;
        } else {
            updatedContent[index][field] = e.target.value;
        }
        setQuestions(updatedContent);
    };

    const handleOptionChange = (e, index, optionIndex) => {
        const updatedContent = [...questions];
        updatedContent[index].answer[optionIndex].answer = e.target.value;
        setQuestions(updatedContent);
    };

    const handleSave = async () => {
        setLoading(true); // Set loading to true while waiting for the response

        const questionMap = JSON.stringify(questions);
        const bodyques = {
            question_map: questionMap
        }
        const apiUrl1 = process.env.REACT_APP_API_URL1;
        const token = localStorage.getItem('token');
        try {
            const response = await axios.post(apiUrl1 + "/api/update_question", bodyques, {
                headers: {
                    'Content-Type': "application/json",
                    "Accept": "*/*",
                    "Access-Control-Allow-Origin": "*",
                    'Authorization': token,
          "X-Api-Version": 'v2'
                }
            });
            console.log(response)
            setLoading(false); // Set loading to false after getting the response
        } catch (error) {
            console.error("Error:", error);
            setLoading(false); // Set loading to false if there's an error
        }

        handleClose();
    };

    const handleSetActive = (event, index) => {
        const newEditedContent = [...questions];
        newEditedContent[index] = {
            ...newEditedContent[index],
            active: event.target.checked ? 0 : 1 // Set active to 0 if checkbox is checked, otherwise set it to 1
        };
        setQuestions(newEditedContent); // Update state with modified questions array
    };

    const renderQuestion = ({ index, style }) => {
        const question = questions[index];
        if (!question || !question.answer) {
            return null;
        }
        return (
            <div key={index} style={{ ...style, marginBottom: '20px', display: 'flex', alignItems: 'flex-start' }}>
                <div style={{ flex: 1, marginRight: '20px' }}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={question.active === 0}
                                onChange={(e) => handleSetActive(e, index)}
                            />
                        }
                        label="Delete"
                    />
                    <TextField
                        value={question.question}
                        onChange={(e) => handleContentChange(e, index, 'question')}
                        variant="outlined"
                        fullWidth
                        multiline
                        label={`Question ${index + 1}`}
                        style={{ marginBottom: '20px' }}
                    />
                    <Typography variant="body1">Answers:</Typography>
                    {question.answer.map((option, optionIndex) => (
                        <div key={optionIndex}>
                            <FormControlLabel
                                control={<Checkbox checked={option.is_correct === 1} />}
                                label={
                                    <TextField
                                        value={option.answer}
                                        onChange={(e) => handleOptionChange(e, index, optionIndex)}
                                        variant="outlined"
                                        fullWidth
                                        multiline
                                        label={`Option ${optionIndex + 1}`}
                                        style={{ margin: '10px 0' }}
                                    />
                                }
                            />
                        </div>
                    ))}
                    <TextField
                        value={question.keywords}
                        onChange={(e) => handleContentChange(e, index, 'keywords')}
                        variant="outlined"
                        fullWidth
                        multiline
                        label="Keywords"
                        style={{ marginTop: '10px', marginBottom: '10px' }}
                    />
                    <TextField
                        value={question.hint}
                        onChange={(e) => handleContentChange(e, index, 'hint')}
                        variant="outlined"
                        fullWidth
                        multiline
                        label="Hint"
                        style={{ marginBottom: '10px' }}
                    />
                    <TextField
                        value={question.explanation}
                        onChange={(e) => handleContentChange(e, index, 'explanation')}
                        variant="outlined"
                        fullWidth
                        multiline
                        label="Explanation"
                        style={{ marginBottom: '20px' }}
                    />
                </div>
                {question.asset && (
                    <img
                        src={question.asset}
                        alt={`Question ${index + 1}`}
                        style={{ width: '200px', height: '200px', borderRadius: '8px' }}
                    />
                )}
            </div>
        );
    };

    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
            <DialogTitle>Generated Questions</DialogTitle>
            <DialogContent>
                <List
                    height={600} // Adjust the height as needed
                    itemCount={questions.length}
                    itemSize={600} // Adjust the height of each item as needed
                    width="100%"
                >
                    {renderQuestion}
                </List>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary" autoFocus>
                    Close
                </Button>
                <Button onClick={handleSave} color="primary">
                    {loading ? <ButtonSpinnerSlot size={24} /> : "Save"}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
